import { useState } from 'react'
import { useAuth } from '../contexts/AuthContext'
import AnonymityToggle from './AnonymityToggle'
import { Send, Loader2 } from 'lucide-react'
import toast from 'react-hot-toast'

const CreatePost = ({ onPostCreated }) => {
  const [content, setContent] = useState('')
  const [isAnonymous, setIsAnonymous] = useState(true)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const { api } = useAuth()

  const handleSubmit = async (e) => {
    e.preventDefault()
    
    if (!content.trim()) {
      toast.error('Please write something before posting')
      return
    }

    setIsSubmitting(true)
    
    try {
      const response = await api.post('/posts', {
        content: content.trim(),
        isAnonymous
      })
      
      if (response.data.success) {
        toast.success('Confession posted!')
        setContent('')
        onPostCreated?.(response.data.data.post)
      }
    } catch (error) {
      toast.error(error.response?.data?.message || 'Failed to post confession')
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <div className="card mb-6">
      <form onSubmit={handleSubmit} className="p-4">
        <div className="mb-4">
          <textarea
            value={content}
            onChange={(e) => setContent(e.target.value)}
            placeholder="Share your confession..."
            className="w-full p-3 border border-gray-200 rounded-lg resize-none focus:ring-2 focus:ring-primary-500 focus:border-transparent"
            rows={3}
            maxLength={2000}
          />
          <div className="flex justify-between items-center mt-2">
            <span className="text-xs text-gray-500">
              {content.length}/2000 characters
            </span>
          </div>
        </div>

        <div className="flex items-center justify-between">
          <AnonymityToggle 
            isAnonymous={isAnonymous}
            onToggle={setIsAnonymous}
          />
          
          <button
            type="submit"
            disabled={isSubmitting || !content.trim()}
            className="btn-primary flex items-center space-x-2 disabled:opacity-50"
          >
            {isSubmitting ? (
              <>
                <Loader2 className="w-4 h-4 animate-spin" />
                <span>Posting...</span>
              </>
            ) : (
              <>
                <Send className="w-4 h-4" />
                <span>Post</span>
              </>
            )}
          </button>
        </div>
      </form>
    </div>
  )
}

export default CreatePost